import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronUpIcon, XIcon } from 'lucide-react';
export function Footer() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <footer className="bg-amber-50 py-6 border-t border-amber-100" data-id="element-194">
      <div className="container mx-auto px-4" data-id="element-195">
        <div className="flex flex-col items-center" data-id="element-196">
          <div className="text-center mb-4" data-id="element-197">
            <p className="text-amber-800 font-bold mb-2" data-id="element-198">PICADAS FÁCILES</p>
            <p className="text-gray-600 text-sm" data-id="element-199">
              © {new Date().getFullYear()} Todos los derechos reservados
            </p>
          </div>
          {/* Bubble navigation button */}
          <div className="relative" data-id="element-200">
            <button onClick={toggleMenu} className={`bg-amber-600 hover:bg-amber-700 text-white rounded-full p-3 shadow-md transition-all ${isMenuOpen ? 'rotate-180' : ''}`} data-id="element-201">
              {isMenuOpen ? <XIcon size={20} data-id="element-202" /> : <ChevronUpIcon size={20} data-id="element-203" />}
            </button>
            {/* Bubble menu */}
            {isMenuOpen && <div className="absolute bottom-16 left-1/2 transform -translate-x-1/2 bg-white rounded-lg shadow-xl p-4 min-w-48 border border-amber-100 z-50 animate-fadeIn" data-id="element-204">
                <div className="flex flex-col space-y-3" data-id="element-205">
                  <Link to="/" className="text-amber-700 hover:text-amber-900 text-center py-2 px-4 rounded-md hover:bg-amber-50" onClick={() => setIsMenuOpen(false)} data-id="element-206">
                    Inicio
                  </Link>
                  <Link to="/terminos-y-condiciones" className="text-amber-700 hover:text-amber-900 text-center py-2 px-4 rounded-md hover:bg-amber-50" onClick={() => setIsMenuOpen(false)} data-id="element-207">
                    Términos y Condiciones
                  </Link>
                  <Link to="/politica-de-privacidad" className="text-amber-700 hover:text-amber-900 text-center py-2 px-4 rounded-md hover:bg-amber-50" onClick={() => setIsMenuOpen(false)} data-id="element-208">
                    Política de Privacidad
                  </Link>
                  <Link to="/contacto" className="text-amber-700 hover:text-amber-900 text-center py-2 px-4 rounded-md hover:bg-amber-50" onClick={() => setIsMenuOpen(false)} data-id="element-209">
                    Contacto
                  </Link>
                </div>
                {/* Triangle pointer */}
                <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-white rotate-45 border-r border-b border-amber-100" data-id="element-210"></div>
              </div>}
          </div>
        </div>
      </div>
      <style jsx data-id="element-211">{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translate(-50%, 10px);
          }
          to {
            opacity: 1;
            transform: translate(-50%, 0);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out forwards;
        }
      `}</style>
    </footer>;
}